module.exports = __webpack_public_path__ + "static/media/zoomIn.ace73d9a.svg";